/**
 * Action label sent with the contact-modal Turnstile widget. Used in two
 * places — the widget renders with `action: CONTACT_INQUIRY_TURNSTILE_ACTION`,
 * and the server-side `verifyTurnstile` call passes the same value as the
 * expected action so Cloudflare's siteverify response is checked against
 * it (defense in depth + per-action analytics in the dashboard).
 */
export const CONTACT_INQUIRY_TURNSTILE_ACTION = "contact_inquiry";

/**
 * Length caps for user-supplied fields on the public contact-inquiry form.
 * Mirrored in `clinicInquirySubmitSchema` (the schema is the source of
 * truth for validation; these constants exist so the UI can render the
 * matching `maxLength` / character-counter without drifting).
 */
export const CLINIC_INQUIRY_MESSAGE_MAX = 2000;
export const CLINIC_INQUIRY_SUBJECT_MAX = 120;

/** Day counts behind the bounded ranges of the admin inquiry summary. */
export const ADMIN_INQUIRY_SUMMARY_RANGE_DAYS = {
	"30d": 30,
	"90d": 90,
} as const;
export const ADMIN_INQUIRY_SUMMARY_TOP_RECIPIENTS = 5;
